import { render, staticRenderFns } from "./special-extension-application-detail.vue?vue&type=template&id=7c98b54a"
import script from "./special-extension-application-detail.vue?vue&type=script&lang=js"
export * from "./special-extension-application-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports